import { HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ASM_DASHBOARD_CONFIG_KEY, STORE_CONFIG_KEY } from '@shared/tools/storage-keys';

/**
 * Handler offline para configurações da loja armazenadas localmente.
 *
 * Cobre:
 * - GET /dashboard/dashboard-config
 * - GET /store/config?channel=
 */
@Injectable({ providedIn: 'root' })
export class StoreConfigOfflineHandler {
  canHandle(req: HttpRequest<unknown>): boolean {
    return (
      req.method === 'GET' && (req.url.includes('/dashboard/dashboard-config') || req.url.includes('/store/config'))
    );
  }

  handle(req: HttpRequest<unknown>): HttpResponse<unknown> {
    const { url } = req;

    if (url.includes('/dashboard/dashboard-config')) {
      const stored = localStorage.getItem(ASM_DASHBOARD_CONFIG_KEY);
      return new HttpResponse({ status: 200, body: stored ? JSON.parse(stored) : {} });
    }

    if (url.includes('/store/config')) {
      const stored = localStorage.getItem(STORE_CONFIG_KEY);
      const channel = req.params.get('channel') ?? 'B2B_COMMERCE_PORTAL';
      return new HttpResponse({
        status: 200,
        body: stored
          ? JSON.parse(stored)
          : {
              code: channel,
              description: 'Store Offline',
              active: true,
              channel,
              paymentLinkExpirationSeconds: 0,
              maxDeliveryDays: 0,
            },
      });
    }

    throw new Error(`[StoreConfigOfflineHandler] Rota não mapeada: ${req.method} ${url}`);
  }
}
